import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { Table, TableBody, TableColumn, TableHeader, TableRow, Th } from 'Components/Table';
import { Icon } from 'Components/Icons';
import styles from './pdfFormTemplates.module.css';

interface Props {
  templates: any;
  fetching: boolean;
  onEditClick: (template: any) => void;
  onDeleteClick: (template: any) => void;
  onSendClick: (template: any) => void;
}

function PdfFormTemplatesList({ templates, fetching, onEditClick, onDeleteClick, onSendClick }: Props) {
  const data = templates?.data || [];

  if (fetching && !data.length) {
    return <div className={styles.emptyState}>Loading...</div>;
  }

  if (data.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No PDF form templates yet.</p>
        <p>Click &quot;Add +&quot; to upload a PDF and start building a form.</p>
      </div>
    );
  }

  return (
    <Table className={`table ${styles.formListWrapper}`}>
      <TableHeader>
        <TableRow>
          <Th>Name</Th>
          <Th>Status</Th>
          <Th>Mark</Th>
          <Th>Created</Th>
          <Th />
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((template: any) => (
          <TableRow key={template.id}>
            <TableColumn>
              <p className={styles.formName}>{template.name}</p>
            </TableColumn>
            <TableColumn>
              <span
                className={`${styles.statusBadge} ${
                  template.status === 'active' ? styles.statusActive : styles.statusDraft
                }`}
              >
                {template.status || 'draft'}
              </span>
            </TableColumn>
            <TableColumn>
              <p>{template.has_signature ? 'Yes' : 'No'}</p>
            </TableColumn>
            <TableColumn>
              <p>{new Date(template.created_at).toLocaleDateString()}</p>
            </TableColumn>
            <TableColumn>
              <div className="d-flex align-items-center" style={{ gap: 12 }}>
                <button
                  type="button"
                  className={styles.editBtn}
                  onClick={() => onEditClick(template)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className={styles.sendBtn}
                  onClick={() => onSendClick(template)}
                >
                  Send
                </button>
                <button
                  type="button"
                  className={styles.trashBtn}
                  aria-label={`Delete ${template.name}`}
                  onClick={() => onDeleteClick(template)}
                >
                  <Icon type="trash" />
                </button>
              </div>
            </TableColumn>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

const PdfFormTemplatesListMemo = memo(PdfFormTemplatesList, areEqual);
export { PdfFormTemplatesListMemo as PdfFormTemplatesList };
